import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  sideList: css`
    width: 435px;
    flex-shrink: 0;
    min-height: 100%;
  `,
  searchInput: css`
    align-self: center;
    margin: 10px 8px;
    width: 100%;
    max-width: 402px;
  `,
  tab: css`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 7px 9px 7px 7px;
    height: auto;
    gap: 6px;
    flex: unset;
    margin-left: 17px;

    border-radius: 12px 12px 0 0;
  `,
  tabContent: css`
    overflow: auto;
    max-height: 100%;
  `,
  createJob: css`
    margin-right: 17px;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
